//export const DEFAULT_BASE_URL = 'https://django-backend-44xk.onrender.com/api';
// export const DEFAULT_BASE_URL = 'http://localhost:8000/api';

export const DEFAULT_BASE_URL = 'https://backend-latest-lzn5.onrender.com/api';


const API_BASE_URL = process.env.REACT_APP_API_BASE_URL ?? DEFAULT_BASE_URL;

let csrfToken = null;

export const clearCSRFToken = () => {
    csrfToken = null;
    console.log('CSRF token cleared');
};

export const getCSRFToken = async () => {
    try {
        console.log('Fetching fresh CSRF token from:', `${API_BASE_URL}/auth/csrf/`);
        const response = await fetch(`${API_BASE_URL}/auth/csrf/`, {
            credentials: 'include'
        });

        if (!response.ok) {
            throw new Error(`CSRF fetch failed: ${response.status}`);
        }

        const data = await response.json();
        csrfToken = data.csrfToken;
        console.log('Retrieved fresh CSRF token:', csrfToken);
        return csrfToken;
    } catch (error) {
        console.error('Error fetching CSRF token:', error);
        csrfToken = null;
        throw error;
    }
};

export const authAPI = {
    register: async (userData) => {
        const token = await getCSRFToken();
        const response = await fetch(`${API_BASE_URL}/auth/register/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRFToken': token
            },
            credentials: 'include',
            body: JSON.stringify(userData)
        });

        const data = await response.json();
        if (!response.ok) {
            throw new Error(data.error || 'Registration failed');
        }
        return data;
    },

    login: async (username, password) => {
        const token = await getCSRFToken();
        const response = await fetch(`${API_BASE_URL}/auth/login/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRFToken': token
            },
            credentials: 'include',
            body: JSON.stringify({ username, password })
        });

        const data = await response.json();
        if (!response.ok) {
            const error = new Error(data.error || 'Login failed');
            // Attach additional error information
            if (data.locked !== undefined) {
                error.locked = data.locked;
            }
            if (data.remaining_time !== undefined) {
                error.remaining_time = data.remaining_time;
            }
            if (data.remaining_attempts !== undefined) {
                error.remaining_attempts = data.remaining_attempts;
            }
            throw error;
        }
        // Clear cached CSRF token as it rotates on login
        csrfToken = null;
        return data;
    },

    logout: async () => {
        const token = await getCSRFToken();
        const response = await fetch(`${API_BASE_URL}/auth/logout/`, {
            method: 'POST',
            headers: {
                'X-CSRFToken': token
            },
            credentials: 'include'
        });

        const data = await response.json();
        if (!response.ok) {
            throw new Error(data.error || 'Logout failed');
        }
        // Clear cached CSRF token
        csrfToken = null;
        return data;
    },

    checkSession: async () => {
        const response = await fetch(`${API_BASE_URL}/auth/session/`, {
            credentials: 'include'
        });

        const data = await response.json();
        return data;
    }
};

export default authAPI;
